import swal from "sweetalert2";
<template>
  <v-card :disabled="loading">
    <div class="text-xs-right close">
      <a href="#" @click.prevent="$emit('closeFundModal', '')">
        <IconBase icon-name="close">
          <ClosePopupIcon />
        </IconBase>
      </a>
    </div>
    <v-card-title>
      <h1 class="card-title">Add a manual entry</h1>
    </v-card-title>
    <v-card-text class="card-text">
      <p>
        Here you may add an historic buy order to the buy history. The bot will
        then treat it is as if it had placed the original order itself.
      </p>
      <p>
        This may be useful if you acquired some funds and would like the bot to
        manage the sale of it, taking advantage, among other things, of the
        trailing stop, for example.
      </p>
      <p v-if="!confirming">
        <v-form ref="form" v-model="formValidated">
          <v-autocomplete
            v-model="selectedMarketName"
            :items="marketsFlattened"
            clearable
            hide-details
            hide-selected
            item-text="title"
            item-value="name"
            placeholder="Market name"
            class="mb-4 select-list"
            :menu-props="{ contentClass: 'openorders-dropdown' }"
            :rules="rules.selectedMarketName"
          >
            <template v-slot:no-data>
              <v-list-tile>
                <v-list-tile-title>
                  Search for a
                  <strong>market</strong>...
                </v-list-tile-title>
              </v-list-tile>
            </template>
            <template v-slot:item="{ item }">
              <v-list-tile-avatar v-if="item.exchange" :size="20" :tile="true">
                <img
                  :src="'/img/' + item.exchange + '_logo.svg'"
                  :alt="item.exchange"
                  width="20"
                  height="20"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="item.title">
                  {{ item }}
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>

          <v-text-field
            v-model="buyPrice"
            placeholder="Buy price"
            :suffix="selectedMarket.base_currency"
            :rules="rules.buyPrice"
            required
          ></v-text-field>

          <v-text-field
            v-model="quantity"
            placeholder="Quantity"
            :suffix="selectedMarket.target_currency"
            :rules="rules.quantity"
            required
          ></v-text-field>
        </v-form>
      </p>
      <div v-else>
        <h3 class="confirm-title">Confirm your input</h3>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                Market name
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ selectedMarket.canonical }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                Buy price
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ buyPrice }} {{ selectedMarket.base_currency }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                Quantity
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{ quantity }} {{ selectedMarket.target_currency }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
      <p v-if="selectedMarketName">
        Please refer to the market settings for {{ selectedMarketName }} to
        configure the bot for this market.
      </p>
      <p v-else>
        Please refer to the market settings to configure the bot for this
        market.
      </p>
      <p>
        It may take up to half an hour before the bot has placed a sell order to
        sell these funds.
      </p>
      <v-btn
        class="btn-ok"
        :disabled="!formValidated"
        :loading="loading"
        @click="confirm"
      >
        <span v-if="confirming">
          I am sure, add manual entry
        </span>
        <span v-else>
          Add manual entry
        </span>
      </v-btn>

      <v-btn v-if="confirming" class="ml-1 btn-cancel" @click="cancel">
        No, take me back
      </v-btn>
      <v-btn
        v-else
        class="ml-1 btn-cancel"
        @click="$emit('closeFundModal', '')"
      >
        Cancel
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.close {
  padding-right: 24px;
  padding-top: 24px;
}
.card-text {
  padding-right: 48px;
  padding-left: 48px;
  padding-bottom: 56px;
}
.v-card__title {
  padding-left: 48px !important;
  padding-top: 4px !important;
  padding-bottom: 8px !important;
}
>>> .v-list__tile__avatar {
  min-width: 36px;
}
>>> .theme--light .v-select__slot .v-icon {
  color: #103a84;
}
>>> .theme--light .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .v-list__tile {
  padding-left: 24px !important;
}

>>> .theme--light.v-input input::placeholder,
>>> .theme--light.v-input textarea::placeholder {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #7395d0;
}
>>> .theme--light .select-list .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .select-list .v-select__slot {
  border: 1px solid #7395d0;
  box-sizing: border-box;
  border-radius: 30px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}
>>> .theme--light .select-list .v-select__slot .v-select__selections {
  padding-left: 16px;
}
.theme--light .btn-ok {
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  box-shadow: none !important;
  margin-left: 0px !important;
  padding: 10px 32px 12px;
}
.theme--light .btn-cancel {
  background: #e6efff !important;
  border-radius: 40px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84;
  box-shadow: none !important;
  padding: 10px 46px 12px;
}
.theme--light .card-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}
.theme--light .confirm-title,
>>> .theme--light .v-list__tile__title,
>>> .theme--light .v-input__icon--append,
>>> .theme--light .v-input__icon--clear,
>>> .theme--light .v-text-field__suffix {
  color: #103a84;
}
>>> .theme--light .v-list__tile__sub-title {
  color: #7395d0;
}
.theme--light p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #8691a4;
}
>>> .theme--light.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: #b8d2ff;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input,
>>> .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #103a84;
}
/*************************/
.theme--dark .btn-ok {
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #e9e9e9;
  box-shadow: none !important;
  margin-left: 0px !important;
  padding: 10px 32px 12px;
}
.theme--dark .btn-cancel {
  background: #959596 !important;
  border-radius: 40px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #212121;
  box-shadow: none !important;
  padding: 10px 46px 12px;
}
.theme--dark .card-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}

>>> .theme--dark .v-list__tile__title,
>>> .theme--dark .v-input__icon--append,
>>> .theme--dark .v-input__icon--clear,
>>> .theme--dark .v-text-field__suffix {
  color: rgba(235, 235, 245, 0.3);
}
.theme--dark .confirm-title {
  color: #e9e9e9;
}
>>> .theme--dark .v-list__tile__sub-title {
  color: #e9e9e9;
}
.theme--dark p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #959596;
}
>>> .theme--dark.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: rgba(235, 235, 245, 0.3);
}
>>> .theme--dark.v-input:not(.v-input--is-disabled) input,
>>> .theme--dark.v-input:not(.v-input--is-disabled) textarea {
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-input--is-focused.primary--text .v-icon {
  color: rgba(235, 235, 245, 0.3) !important;
}
>>> .theme--dark .v-select__slot .v-icon {
  color: #ffffff !important;
}
>>> .theme--dark .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
>>> .theme--dark .v-list__tile {
  padding-left: 24px !important;
}
>>> .theme--dark.v-list {
  background: #303030;
}
>>> .theme--dark.v-input.v-input--is-focused.primary--text {
  color: rgba(235, 235, 245, 0.3) !important;
  caret-color: rgba(235, 235, 245, 0.3) !important;
}

>>> .theme--dark .select-list .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .select-list .v-select__slot {
  border: 1px solid rgba(235, 235, 245, 0.6);
  box-sizing: border-box;
  border-radius: 30px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}
>>> .theme--dark .select-list .v-select__slot .v-select__selections {
  padding-left: 16px;
}

@media (max-width: 600px) {
  .card-text {
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 16px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import swal from "sweetalert2";
import { bugsnagClient } from "~/plugins";
import IconBase from "../icons/IconBase";
import ClosePopupIcon from "../icons/ClosePopupIcon";

function prepareInputForValidation(v) {
  if (typeof v !== "string" && v instanceof String === false) {
    return "";
  }

  if (v.charAt(0) === ".") {
    v = "0" + v;
  }

  if (v.charAt(v.length - 1) === ".") {
    v = v.substring(0, v.length - 1);
  }

  return v;
}

export default {
  name: "AddManualBuyOrderAccumulatedFunds",
  components: {
    IconBase,
    ClosePopupIcon
  },
  data() {
    return {
      loading: false,
      selectedMarketName: null,
      selectedMarketNameCanonical: null,
      selectedMarket: {
        base_currency: null,
        target_currency: null,
        name: null,
        canonical: null
      },
      confirming: false,
      buyPrice: null,
      quantity: null,
      formValidated: false,
      rules: {
        buyPrice: [
          v => !!v || "Buy price cannot be empty",
          v =>
            new RegExp("^\\d+(\\.\\d+)?$").test(prepareInputForValidation(v)) ||
            "Buy price should be a number",
          v =>
            parseFloat(prepareInputForValidation(v)) > 0 ||
            "Buy price should be above zero"
        ],
        quantity: [
          v => !!v || "Quantity cannot be empty",
          v =>
            new RegExp("^\\d+(\\.\\d+)?$").test(prepareInputForValidation(v)) ||
            "Quantity should be a number",
          v =>
            parseFloat(prepareInputForValidation(v)) > 0 ||
            "Quantity should be above zero"
        ],
        selectedMarketName: [v => !!v || "Market cannot be empty"]
      }
    };
  },
  watch: {
    selectedMarketName() {
      if (
        typeof this.selectedMarketName !== "undefined" &&
        this.selectedMarketName !== null &&
        this.selectedMarketName.length > 0
      ) {
        const market = this.marketsFlattened.find(
          item => item.name === this.selectedMarketName
        );
        if (typeof market !== "undefined") {
          this.selectedMarket = market;
          this.selectedMarket.canonical =
            market.exchange +
            ":" +
            market.target_currency +
            "/" +
            market.base_currency;
          return;
        }
      }
      return (this.selectedMarket = {
        base_currency: null,
        target_currency: null,
        name: null
      });
    }
  },
  created: function() {
    if (!this.$store.getters["markets/marketsAll"]) {
      this.$store.dispatch("markets/fetchMarketsAll");
    }
  },
  methods: {
    confirm() {
      if (this.confirming && this.loading) {
        return;
      }

      if (this.confirming) {
        return this.submit();
      }

      this.confirming = true;
      this.quantity = prepareInputForValidation(this.quantity);
      this.buyPrice = prepareInputForValidation(this.buyPrice);
    },
    cancel() {
      this.confirming = false;
    },
    async submit() {
      this.loading = true;

      try {
        await axios.post("/api/v1/openorders/add", {
          market: this.selectedMarketName,
          canonical_name: this.selectedMarket.canonical,
          buy_price: this.buyPrice,
          quantity: this.quantity
        });

        // await this.$store.dispatch("markets/fetchMarkets"); // enable this if markets needs to be reloaded
        await this.$store.dispatch("auth/refreshUserHistory");
        this.$emit("close-dialog");

        this.loading = false;
        this.quantity = null;
        this.buyPrice = null;
        this.selectedMarketName = null;
        this.confirming = false;
      } catch (error) {
        await swal({
          title: "Problem adding manual buy entry",
          html: "Please try again later.",
          showConfirmButton: false,
          showCloseButton: true,
          customClass: this.themeDark
            ? "swal-type-error-dark"
            : "swal-type-error",
          imageUrl: "/img/popup_img_error.png",
          imageHeight: 80,
          imageWidth: 80
        });

        bugsnagClient.notify(error);

        this.loading = false;
      }
    }
  },
  computed: {
    marketsFlattened() {
      let flattenedMarkets = [];

      if (this.markets) {
        flattenedMarkets = this.markets.map(market => {
          market.title =
            market.exchange +
            ":" +
            market.target_currency +
            "/" +
            market.base_currency;
          return market;
        });
      }
      return flattenedMarkets;
    },
    ...mapGetters({
      markets: "markets/marketsAll",
      themeDark: "settings/darkmode"
    })
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/openorders/AddManualBuyOrderAccumulatedFunds.vue